import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';

import { getFeatureDecision } from '../config';

// This file is imported and used by a observeFatalError before hydrateContext is called, so needs default values in getFeatureDecisions for the first invocation where window.config will not yet exist.
export const shouldShowHotelsResults = (): boolean =>
  getFeatureDecision(FEATURE_DECISION_KEYS.SHOW_COMBINED_RESULTS_HOTELS);
